import { useQuery } from '@tanstack/react-query';

import { buildGetRequest } from '@/hooks/base_hooks';
import type { SurveyResponseDetail } from '@/types/survey';

/**
 * GET /api/survey/<slug>/response/ - Fetches current-user responses in this survey.
 * Used on /pesquisa/perfil to show "já começou" and "Ver as minhas respostas" for the chosen trilha.
 * Returns data: [] when there are no responses.
 */
export function useSurveyResponse(slug: string) {
  const queryKey = ['survey', slug, 'response'];

  return useQuery({
    queryKey,
    queryFn: async (): Promise<SurveyResponseDetail[]> => {
      if (!slug) return [];
      const request = buildGetRequest(['survey', slug, 'response'], {});
      try {
        return (await request()) as SurveyResponseDetail[];
      } catch (err: unknown) {
        const status = (err as { response?: { status?: number } })?.response?.status;
        if (status === 404) return [];
        throw err;
      }
    },
    enabled: !!slug,
  });
}
